import { ImageCropper, type ImageCropperProperties } from '../image-cropper';
import { ImageDragger } from '../image-dragger';
import type { ImageDraggerProperties } from '../image-dragger/image-upload';

type P<T extends { url: string }> = {
  cropper?: Omit<ImageCropperProperties, 'children'>;
  dragger: ImageDraggerProperties<T>;
  fileList?: ImageDraggerProperties<T>['fileList'];
  id?: ImageDraggerProperties<T>['id'];
  onChange?: ImageDraggerProperties<T>['onChange'];
};

const ImageDraggerWithCrop = <T extends { url: string }>({ cropper, dragger, ...rest }: P<T>) => (
  <ImageCropper {...cropper}>
    <ImageDragger {...dragger} {...rest} />
  </ImageCropper>
);

export default ImageDraggerWithCrop;
